import { makeStyles } from '@material-ui/core';
import { TenantConfigurationIcon } from '../../core/themes/icons/TenantConfigurationIcon';
import React from 'react';
import {
  Datagrid,
  List,
  Responsive,
  TextInput,
  SimpleList,
  TextField,
  TopToolbar,
  Pagination
} from 'react-admin';

import LinkField from '../../core/components/LinkField';
import Empty from '../../core/components/list/Empty';
import Filter from '../../core/components/list/StyledFilter';
import ListTitleBar from '../../core/components/ListTitleBar';
import {
  predictiveSearchFormatter,
  predictiveSearchParser
} from '../../core/utils';

const useStyles = makeStyles({
  root: {
    marginRight: 'auto'
  }
});

const useStylesForInput = makeStyles({
  textInput: {
    minWidth: '225px'
  }
});

const Actions = ({
  displayedFilters,
  filters,
  filterValues,
  resource,
  showFilter
}) => {
  const classes = useStyles();
  return (
    <TopToolbar classes={classes}>
      {filters &&
        React.cloneElement(filters, {
          resource,
          showFilter,
          displayedFilters,
          filterValues,
          context: 'button'
        })}
    </TopToolbar>
  );
};

const TenantConfigurationFilters = props => {
  const classes = useStylesForInput();

  return (
    <Filter variant="standard" {...props}>
      <TextInput
        label="Search by Name or Category"
        source="nameOrCategory"
        alwaysOn
        className={classes.textInput}
        parse={predictiveSearchParser}
        format={predictiveSearchFormatter}
      />
    </Filter>
  );
};

const TenantConfigurationTitle = props => {
  return (
    <ListTitleBar
      type="Global Configuration"
      icon={<TenantConfigurationIcon />}
      hasCreatePermission={props.hasCreatePermission}
    />
  );
};

const TenantConfigurationList = props => {
  const {
    hasCreatePermission,
    hasEditPermission,
    hasDeletePermission,
    hasReadPermission,
    userProfile,
    ...rest
  } = props;
  return (
    <List
      {...rest}
      sort={{ field: 'name', order: 'ASC' }}
      exporter={false}
      title={
        <TenantConfigurationTitle hasCreatePermission={hasCreatePermission} />
      }
      filters={<TenantConfigurationFilters />}
      perPage={20}
      pagination={<Pagination rowsPerPageOptions={[20, 25, 30]} />}
      bulkActionButtons={false}
      actions={<Actions />}
      empty={<Empty />}
      syncWithLocation
    >
      <Responsive
        small={
          <SimpleList
            primaryText={record => record.name}
            secondaryText={record => record.id}
            tertiaryText={() => ''}
          />
        }
        medium={
          <Datagrid>
            <LinkField label="Name" source="name" />
            <TextField
              label="Description"
              source="description"
              id="Description"
            />
            <TextField label="Category" source="category" id="Category" />
          </Datagrid>
        }
      />
    </List>
  );
};

export default TenantConfigurationList;
